import { CATEGORY_SWATCH_CLASS_NAMES } from './styles';
import { CATEGORY_LABELS } from '@lib/whats-new/model';
import type { ProductUpdateCategory } from '@lib/sanity/types';

export const CategorySwatch = ({
  category,
  className = 'h-2.5 w-2.5 rounded-sm'
}: {
  category: ProductUpdateCategory;
  className?: string;
}) => (
  <span
    aria-hidden="true"
    className={`inline-block shrink-0 ${className} ${CATEGORY_SWATCH_CLASS_NAMES[category]}`}
  />
);

export const CategoryLabel = ({
  category
}: {
  category: ProductUpdateCategory;
}) => (
  <span className="inline-flex items-center gap-[7px] font-bold text-landing-ink">
    <CategorySwatch category={category} />
    {CATEGORY_LABELS[category]}
  </span>
);
